// src/@common/models/pdca.ts
import { Status } from './status';
import { ProblemIdentification } from './problem-identification';
import { ConclusionPdca } from './conclusion-pdca';
import { AnalysisTab } from './analysis-process';
import { PdcaFile } from './pdca-files';

export class Pdca {
    id?: number; 
    // companyId?: number; //posiblemente se quite, preguntar a ferenc
    problemIdentification: ProblemIdentification;
    causeAnalysis: AnalysisTab[];
    conclusion: ConclusionPdca;
    files: PdcaFile[];
    status: Status;
    createdAt?: string;
    // createdUserId?: number;
    updatedAt?: Date;
    // updatedUserId?: number; 

    constructor() {
        this.problemIdentification = new ProblemIdentification();
        this.causeAnalysis = [];
        this.conclusion = new ConclusionPdca();
        this.files = [];
        this.status = new Status();
    }
}